/**
 * @generated SignedSource<<ae6fea1b092572f2b01b467029189fed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShopGrid_landingPage$data = {
  readonly grid: {
    readonly items: ReadonlyArray<{
      readonly description: string | null;
      readonly imageUrl: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ShopGrid_landingPage";
};
export type ShopGrid_landingPage$key = {
  readonly " $data"?: ShopGrid_landingPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShopGrid_landingPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShopGrid_landingPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LandingPageGrid",
      "kind": "LinkedField",
      "name": "grid",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LandingPageGridItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LandingPage",
  "abstractKey": null
};

(node as any).hash = "33de3e3749d1393933583ebec1c40744";

export default node;
